import React from 'react';

import { CaseChallengeItemModel, CaseChallengesTabContent } from '../case-challenges-tab-content';

export const Case2ChallengesTabContent = React.memo(() => {
  const Case2Challenges = React.useMemo<CaseChallengeItemModel[]>(() => {
    const case1Challenges: CaseChallengeItemModel[] = [
      {
        type: 'default',
        icon: 'globe',
        text: 'Increasing network complexity and diverse services putting additional demands on operational teams',
      },
      {
        type: 'default',
        icon: 'node',
        text: 'Incident driven operations with this complexity leads to higher MTTR and lower network availability',
      },
      {
        type: 'default',
        icon: 'accelerometer',
        text: 'Customer experience is impacted due to increased performance degradations in the network',
      },
    ];

    return case1Challenges;
  }, []);

  return <CaseChallengesTabContent items={Case2Challenges} />;
});
